import { createContext, useContext, ReactNode, useState, useEffect, useMemo } from 'react';
import { TeamMember } from '../team-member';
import { TeamMemberCreationItention } from '../data-layer/TeamRepository';
import { TeamRepositoryBuilder } from '../data-layer/TeamRepositoryBuilder';

type ContextState = {
  teamMembers: TeamMember[];
  addTeamMember: (member: TeamMemberCreationItention) => Promise<void>;
  removeMember: (member: TeamMember) => Promise<void>;
}

const TeamContext = createContext<ContextState | undefined>(undefined);

export const TeamProvider = ({ children }: { children: ReactNode }) => {
  const teamRepository = useMemo(() => new TeamRepositoryBuilder().build(), []);

  const [teamMembers, setTeamMember] = useState<TeamMember[]>([]);
  const teamState: ContextState = {
    teamMembers,
    addTeamMember: async (member: TeamMemberCreationItention) => {
      const newMember = await teamRepository.addMember(member);
      setTeamMember([...teamMembers, newMember])
    },
    removeMember: async (member: TeamMember) => {
      await teamRepository.removeMember(member);
      const newList = teamMembers.filter(currentMemberInTeam => member.id !== currentMemberInTeam.id);
      setTeamMember(newList);
    }
  }

  useEffect(() => {
    const fetchTeamMembers = async () => {
      const list = await teamRepository.findAllTeamMembers();
      setTeamMember(list);
    }
    fetchTeamMembers();
  }, [teamRepository]);

  return <TeamContext.Provider value={teamState}>
    {children}
  </TeamContext.Provider>
};

export const useTeam = () => {
  const context = useContext(TeamContext)
  if (context === undefined) {
    throw new Error('useTeam must be used within a TeamProvider')
  }
  return context
}